<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TableList from '@/components/lists/TableList.vue'
import PageNavigation from '@/components/navigate/PageNavigation.vue'
import Progress from '@/components/forms/Progress.vue'
import { useOrdersStore } from '@/store/orders'
import { normalizeApiError } from '@/utils/apiError'

const store = useOrdersStore()
const router = useRouter()
const route = useRoute()
const currentPage = ref(Number(route.query.page) || 1)
const type = ref('')
const errorMessage = ref('')

const titles = ref([
  { title: 'Id', key: 'id' },
  { title: 'Статус', key: 'status' },
  { title: 'Сума', key: 'total' },
  { title: 'Клієнт', key: 'customer' },
])

async function loadOrders(page = currentPage.value) {
  type.value = 'loading'
  errorMessage.value = ''

  try {
    await store.getOrders(page)
    type.value = ''
  } catch (error) {
    type.value = 'error'
    errorMessage.value = normalizeApiError(error, {
      fallbackMessage: 'Не вдалося завантажити список замовлень.',
    }).message
  }
}

onMounted(async () => {
  await loadOrders()
})

watch(currentPage, async (newPage) => {
  await router.push({ query: { page: newPage } })
  await loadOrders(newPage)
})
</script>

<template>
  <Progress :type="type" :error-message="errorMessage" loading-message="Завантаження списку..." />
  <TableList :rows="store.allOrders" :titles="titles" detailRoutName="OrdersDetail" blockTitle="Замовлення" />
  <PageNavigation v-model="currentPage" :totalPages="store.countPages" :maxVisible="5" />
</template>

<style scoped lang="scss">

</style>
